/* Copyright 2021, Milkdown by Mirone. */
import { createCmd, createCmdKey } from '@milkdown/core';
import { createNode, createShortcut } from '@milkdown/utils';
import { wrapIn } from 'prosemirror-commands';
import { wrappingInputRule } from 'prosemirror-inputrules';
import { SupportedKeys } from '../supported-keys';
export const WrapInBulletList = createCmdKey();
const id = 'bullet_list';
export const bulletList = createNode((_, utils) => {
    return {
        id,
        schema: {
            content: 'listItem+',
            group: 'block',
            parseDOM: [{ tag: 'ul' }],
            toDOM: (node) => {
                return ['ul', { class: utils.getClassName(node.attrs, 'bullet-list') }, 0];
            },
        },
        parser: {
            match: ({ type, ordered }) => type === 'list' && !ordered,
            runner: (state, node, type) => {
                state.openNode(type).next(node.children).closeNode();
            },
        },
        serializer: {
            match: (node) => node.type.name === id,
            runner: (state, node) => {
                state.openNode('list', undefined, { ordered: false }).next(node.content).closeNode();
            },
        },
        inputRules: (nodeType) => [wrappingInputRule(/^\s*([-+*])\s$/, nodeType)],
        commands: (nodeType) => [createCmd(WrapInBulletList, () => wrapIn(nodeType))],
        shortcuts: {
            [SupportedKeys.BulletList]: createShortcut(WrapInBulletList, 'Mod-Shift-8'),
        },
    };
});
//# sourceMappingURL=bullet-list.js.map